import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";

import Home from './pages/Home';
import Contacto from './pages/Contacto';
import RentaCajasSecas from './pages/RentaCajasSecas';
import 'animate.css';
import Blog from './pages/Blog/Blog';
import Blog1 from './pages/Blog/components/pages/Blog1';
import Blog2 from './pages/Blog/components/pages/Blog2';
import Blog3 from './pages/Blog/components/pages/Blog3';
import Blog4 from './pages/Blog/components/pages/Blog4';
import Blog5 from './pages/Blog/components/pages/Blog5';
import RentaPlataformas from './pages/RentaPlataformas';
import VentaRefacciones from './pages/VentaRefacciones';
import Catalogo from './pages/Venta/Catalogo';
import { HelmetProvider } from 'react-helmet-async';

const theme = createTheme({
  typography: {
    fontFamily: 'Mulish'
  }
});

const App = () => {
  let routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "contacto", element: <Contacto /> },
    { path: "renta-cajas-secas-hidalgo", element: <RentaCajasSecas /> },
    { path: "renta-plataformas-hidalgo", element: <RentaPlataformas /> },
    { path: "venta-refacciones", element: <VentaRefacciones /> },
    { path: "blog", element: <Blog /> },
    { path: "blog/guia-para-elegir-caja-seca-ideal", element: <Blog1 /> },
    { path: "blog/requisitos-para-transportar-carga-en-mexico", element: <Blog2 /> },
    { path: "blog/como-ahorrar-costos-rentando-cajas-secas", element: <Blog3 /> },
    { path: "blog/zonas-estrategicas-de-operacion-en-hidalgo", element: <Blog4 /> },
    { path: "blog/errores-comunes-al-rentar-una-caja-seca", element: <Blog5 /> },
    { path: "venta/catalogo", element: <Catalogo /> },
  ]);
  return routes;
};



const AppWrapper  = () => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <App />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default AppWrapper ;
